import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export default function Loader({ onDone }) {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 420);
    const t2 = setTimeout(() => setPhase(2), 900);
    const t3 = setTimeout(() => onDone(), 1650);
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, [onDone]);

  return (
    <AnimatePresence>
      <motion.div
        key="loader"
        className="fixed inset-0 z-[999] flex flex-col items-center justify-center grain"
        style={{ background: "#F8F9FA" }}
        exit={{ y: "-100%" }}
        transition={{ duration: 0.9, ease }}
        data-testid="loading-screen"
      >
        <div className="relative flex flex-col items-center">
          {/* logo mark draws itself */}
          <svg width="72" height="72" viewBox="0 0 100 100" fill="none" className="mb-6">
            <motion.path
              d="M40 12 h20 v18 h18 v20 h-18 v18 h-20 v-18 h-18 v-20 h18 z"
              stroke="#1F6FEB" strokeWidth="3" fill="#1F6FEB"
              initial={{ pathLength: 0, fillOpacity: 0 }}
              animate={{ pathLength: 1, fillOpacity: 1 }}
              transition={{ pathLength: { duration: 0.7, ease }, fillOpacity: { delay: 0.55, duration: 0.4 } }}
            />
            <motion.path
              d="M30 62 C46 58 60 50 78 30"
              stroke="#0A1128" strokeWidth="4" strokeLinecap="round" fill="none"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.6, ease, delay: 0.35 }}
            />
            <motion.path
              d="M70 24 l10 4 l-4 10"
              stroke="#0A1128" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.3, ease, delay: 0.8 }}
            />
          </svg>

          {/* precision line sweep */}
          <motion.div
            className="h-px bg-[#1F6FEB]"
            initial={{ width: 0 }}
            animate={{ width: phase >= 1 ? 240 : 0 }}
            transition={{ duration: 0.7, ease }}
          />

          <div className="mt-5 text-center overflow-hidden">
            <div className="line-mask">
              <motion.div
                className="text-2xl sm:text-3xl font-extrabold tracking-[0.25em] text-[#0A1128]"
                initial={{ y: "110%" }}
                animate={{ y: phase >= 1 ? "0%" : "110%" }}
                transition={{ duration: 0.7, ease }}
              >
                CLINIXPORT
              </motion.div>
            </div>
            <div className="line-mask">
              <motion.div
                className="mt-1 text-xs sm:text-sm font-bold tracking-[0.5em] text-[#1F6FEB]"
                initial={{ y: "110%" }}
                animate={{ y: phase >= 2 ? "0%" : "110%" }}
                transition={{ duration: 0.6, ease }}
              >
                GLOBAL
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
